import { motion, useReducedMotion } from "framer-motion";
import { useId } from "react";

/**
 * The Siaq Line — a single copper/coral flowing line that recurs across the site.
 * variant: "flow" (horizontal river), "descent" (long vertical), "wrap" (framing bracket)
 */
export default function SiaqLine({ variant = "flow", className = "", animate = true, strokeWidth = 2.5 }) {
  const id = useId().replace(/:/g, "");
  const reduced = useReducedMotion();
  const doAnimate = animate && !reduced;

  const paths = {
    flow: "M0,60 C160,10 320,110 480,60 C640,10 800,110 960,60 C1100,20 1180,80 1200,60",
    descent: "M60,0 C10,120 110,240 60,360 C10,480 110,600 60,760",
    wrap: "M20,20 L1180,20 L1180,320 L20,320 Z",
  };
  const viewBox = variant === "descent" ? "0 0 120 760" : variant === "wrap" ? "0 0 1200 340" : "0 0 1200 120";
  const d = paths[variant] || paths.flow;

  return (
    <svg
      className={className}
      viewBox={viewBox}
      fill="none"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={`siaq-${id}`} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#E56B6F" />
          <stop offset="55%" stopColor="#EAAD8C" />
          <stop offset="100%" stopColor="#E56B6F" />
        </linearGradient>
      </defs>
      <motion.path
        d={d}
        stroke={`url(#siaq-${id})`}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
        initial={doAnimate ? { pathLength: 0, opacity: 0 } : false}
        whileInView={doAnimate ? { pathLength: 1, opacity: 1 } : undefined}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
      />
    </svg>
  );
}
